import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchPart, PartDto } from "#modules/parts/infra/fetchPart.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const PART_QUERY_KEY = queryKeys.parts.all;

export const partQuery = (id: string | undefined) => ({
  queryKey: queryKeys.parts.detail(id),
  queryFn: () => fetchPart({ id }),
  staleTime: STALE_TIME,
});

export const getPartQueryData = (queryClient: QueryClient, id: string): PartDto | undefined => {
  return queryClient.getQueryData<PartDto>(queryKeys.parts.detail(id));
};

type PartQueryDataUpdater =
  | PartDto
  | undefined
  | ((old: PartDto | undefined) => PartDto | undefined);

export const setPartQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: PartQueryDataUpdater,
): PartDto | undefined => {
  return queryClient.setQueryData<PartDto>(queryKeys.parts.detail(id), updater);
};
